import { render, staticRenderFns } from "./NavigationAndPageDetails.vue?vue&type=template&id=6b1dcbe9"
import script from "./NavigationAndPageDetails.vue?vue&type=script&lang=js"
export * from "./NavigationAndPageDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports